import { render, staticRenderFns } from "./platformInstruction.vue?vue&type=template&id=49268674&scoped=true&"
import script from "./platformInstruction.vue?vue&type=script&lang=js&"
export * from "./platformInstruction.vue?vue&type=script&lang=js&"
import style0 from "./platformInstruction.vue?vue&type=style&index=0&id=49268674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49268674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49268674')) {
      api.createRecord('49268674', component.options)
    } else {
      api.reload('49268674', component.options)
    }
    module.hot.accept("./platformInstruction.vue?vue&type=template&id=49268674&scoped=true&", function () {
      api.rerender('49268674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/platformInstruction.vue"
export default component.exports